import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HelperService } from '../helpers/helper.service';
import { filterationParams } from '../params/params';
import { environment } from 'src/environments/environment.development';

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  baseUrl: string = environment.basicUrl;
  version: string = environment.version

  constructor(private http: HttpClient, private _helper: HelperService) { }

  getCountries() {
    let params = new filterationParams
    return this._helper.CallRequestList(`organization/countries`, this._helper.CreateRequestParameters(params.notPaginationParams));
  }

  getCurrencies() {
    let params = new filterationParams
    return this._helper.CallRequestList(`organization/currencies`, this._helper.CreateRequestParameters(params.notPaginationParams));
  }

  getGender() {
    let params = new filterationParams
    return this._helper.CallRequestList(`hr/lookup/gender-type`, this._helper.CreateRequestParameters(params.notPaginationParams));
  }

  getReligion() {
    let params = new filterationParams
    return this._helper.CallRequestList(`hr/lookup/religion`, this._helper.CreateRequestParameters(params.notPaginationParams));
  }

  getMaritalStatus() {
    let params = new filterationParams
    return this._helper.CallRequestList(`hr/lookup/marital-status`, this._helper.CreateRequestParameters(params.notPaginationParams));
  }

  getMilitaryStatus() {
    let params = new filterationParams
    return this._helper.CallRequestList(`hr/lookup/military-status`, this._helper.CreateRequestParameters(params.notPaginationParams));
  }

  getNationalType() {
    let params = new filterationParams
    return this._helper.CallRequestList(`hr/lookup/national-i-d-type`, this._helper.CreateRequestParameters(params.notPaginationParams));
  }

  getRegistrationNationalities() {
    return this.http.get(`${this.baseUrl}/${this.version}/hr/lookup/nationality`)
  }

  getNationalities() {
    let params = new filterationParams
    return this._helper.CallRequestList(`hr/lookup/nationality`, this._helper.CreateRequestParameters(params.notPaginationParams));
  }

  getRelatedData(moduleName: string, parentNodeName: string, parentNodeId: Number, childNodeName: string) {
    let params = new filterationParams
    return this._helper.CallRequestList(`${moduleName}/get_related_data/${parentNodeName}/${parentNodeId}/${childNodeName}`, this._helper.CreateRequestParameters(params.notPaginationParams));
  }
}
